import React from "react";
import { Clock } from "lucide-react";
import { SmartImage } from "./media";
import { AddBtn } from "./Carousels";
import { brl, discountPct, BADGES } from "../../lib/format";

function Badges({ list, soldOut }) {
  const all = [...(list || [])];
  if (soldOut && !all.includes("esgotado")) all.push("esgotado");
  if (!all.length) return null;
  return (
    <div className="flex flex-wrap gap-1 mb-1">
      {all.slice(0, 3).map((b) => {
        const cfg = BADGES[b];
        if (!cfg) return null;
        return <span key={b} className={`text-[9px] font-bold px-1.5 py-0.5 rounded ${cfg.cls}`}>{cfg.label}</span>;
      })}
    </div>
  );
}

export function CatalogItem({ p, onOpen, onAdd }) {
  const promo = p.promo_price && p.promo_price < p.price;
  const price = promo ? p.promo_price : p.price;
  const pct = discountPct(p.price, p.promo_price);
  return (
    <div
      className={`flex gap-3 p-3 rounded-2xl menu-surface border menu-border ${p.sold_out ? "opacity-70" : ""}`}
      data-testid={`catalog-item-${p.id}`}
    >
      <button onClick={() => onOpen(p)} className="flex-1 text-left min-w-0">
        <Badges list={p.badges} soldOut={p.sold_out} />
        <h3 className="font-head font-bold text-[15px] leading-snug line-clamp-1 menu-text">{p.name}</h3>
        <p className="text-xs menu-muted line-clamp-2 mt-0.5">{p.description}</p>
        <div className="flex items-center gap-3 mt-2">
          <span className="font-head font-extrabold price-final">{brl(price)}</span>
          {promo && <span className="text-xs menu-faint line-through">{brl(p.price)}</span>}
          {p.prep_time ? <span className="flex items-center gap-1 text-[11px] menu-faint"><Clock size={11} />{p.prep_time}min</span> : null}
        </div>
      </button>
      <div className="relative shrink-0">
        <button onClick={() => onOpen(p)}>
          <SmartImage src={p.image} className="h-24 w-24 rounded-xl" />
          {pct > 0 && <span className="absolute top-1 left-1 text-[9px] font-bold bg-rose-600 text-white px-1.5 py-0.5 rounded-full">-{pct}%</span>}
        </button>
        <div className="absolute -bottom-2 -right-1">
          {p.sold_out
            ? <span className="text-[9px] font-bold bg-zinc-800 text-zinc-400 px-2 py-1.5 rounded-lg">Esgotado</span>
            : <AddBtn onClick={() => onAdd(p)} tid={`catalog-add-${p.id}`} />}
        </div>
      </div>
    </div>
  );
}

export function CategoryChips({ categories, active, onSelect }) {
  return (
    <div className="sticky top-0 z-30 menu-sticky backdrop-blur-md border-b menu-border">
      <div className="flex gap-2 overflow-x-auto no-scrollbar px-5 py-3">
        <Chip label="Todos os itens" active={active === "all"} onClick={() => onSelect("all")} tid="chip-all" />
        {categories.map((c) => (
          <Chip key={c.id} label={c.name} active={active === c.id} onClick={() => onSelect(c.id)} tid={`chip-${c.id}`} />
        ))}
      </div>
    </div>
  );
}

function Chip({ label, active, onClick, tid }) {
  return (
    <button
      onClick={onClick} data-testid={tid}
      className={`shrink-0 whitespace-nowrap px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
        active ? "hmmm-gradient text-white" : "menu-chip menu-muted"
      }`}
    >
      {label}
    </button>
  );
}
